module.exports = __webpack_public_path__ + "img/pinterest-p.90e48730.svg";